function CustomerPlantsPanel({
  cardStyle,
  sectionTitleStyle,
  emptyBoxStyle,
  impiantiCliente,
  onOpenPlant,
}) {
  return (
    <div style={cardStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "14px",
        }}
      >
        <h2 style={sectionTitleStyle}>
  Impianti del cliente ({impiantiCliente.length})
</h2>
      </div>

      {impiantiCliente.length === 0 ? (
        <div style={emptyBoxStyle}>Nessun impianto collegato.</div>
      ) : (
        <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "12px",

    maxHeight: impiantiCliente.length > 4 ? "520px" : "none",
    overflowY: impiantiCliente.length > 4 ? "auto" : "visible",
    paddingRight: impiantiCliente.length > 4 ? "6px" : 0,
  }}
>
          {impiantiCliente.map((impianto) => (
            <div
              key={impianto.id}
              onClick={() => onOpenPlant && onOpenPlant(impianto.id)}
              style={{
                ...emptyBoxStyle,
                cursor: "pointer",
                transition: "all 0.18s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 18px rgba(15,60,117,0.12)";
                e.currentTarget.style.borderColor = "#7da7dc";
                e.currentTarget.style.backgroundColor = "#eef5ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.borderColor = "#dbe4f0";
                e.currentTarget.style.backgroundColor = "#f8fbff";
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <strong>{impianto.plant_type || "Impianto"}</strong>

                <span
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                  }}
                >
                  {impianto.brand || "—"}
                </span>
              </div>

              <div>
                <strong>Modello:</strong> {impianto.model || "—"}
              </div>

              <div>
                <strong>Matricola:</strong> {impianto.serial_number || "—"}
              </div>

              <div>
                <strong>Città:</strong> {impianto.city || "—"}
              </div>

              <div
                style={{
                  marginTop: "12px",
                  textAlign: "right",
                  fontWeight: 700,
                  color: "#0f3c75",
                  fontSize: "14px",
                }}
              >
                Apri impianto →
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomerPlantsPanel;